<div class="modal">
  <div class="card card--lg">
    <div class="card-header">
      <div class="card-title">
        Detalji radnog zahteva: <span>{{ prevWorkRequestData.name }}</span>
      </div>
    </div>
    <div class="card-body scrollable scrollable--md">
      <div class="row">
        <div class="col-12">
          <div class="d-flex">
            <div *ngFor="let sector of prevWorkRequestData.sectors">
              <app-tag class="mr-10" [sector]="sector.name" [isActive]="true"></app-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="form-control mb-20 mt-20 pt-20 pb-20 pointer"
           *ngIf="prevWorkRequestData.materialsInfo && prevWorkRequestData.materialsInfo.length > 0"
           (click)="onToggleMaterialsSection()">
        <div class="row">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between font-18">
              <div>Materijali</div>
              <i [ngClass]="isMaterialsSectionOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
            </div>
          </div>
          <div class="col-12" *ngIf="isMaterialsSectionOpen">
            <div class="mt-10 mb-20 p-10 border" *ngFor="let material of prevWorkRequestData.materialsInfo">
              <div class="d-flex mb-5">
                <app-tag class="mr-2" [sector]="material.sector" [isActive]="true"></app-tag>
                <b>{{ material.name }}</b>
                - {{ material.quantityPlanned | digitFormat }} {{ material.materialUnit }}
              </div>
              <div class="mb-5"><b>Jedinična cena:</b> {{ material.materialCurrentUnitPrice }}</div>
              <div><b>Ukupna cena:</b> {{ material.materialCurrentUnitPrice * material.quantityPlanned | digitFormat }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-control mt-20 pt-20 pb-20 pointer"
           *ngIf="prevWorkRequestData.operationsInfo && prevWorkRequestData.operationsInfo.length > 0"
           (click)="onToggleOperationsSection()">
        <div class="row">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between font-18">
              <div>Operacije</div>
              <i [ngClass]="isOperationsSectionOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
            </div>
          </div>
          <div class="col-12" *ngIf="isOperationsSectionOpen">
            <div class="mt-10 mb-20 p-10 border" *ngFor="let operation of prevWorkRequestData.operationsInfo">
              <div class="mb-10">
                <b>{{ operation.operationName }} ({{ operation.machineName }})</b>
              </div>
              <div class="d-flex justify-content-between">
                <div>
                  <app-tag class="mr-10" [sector]="operation.sector" [isActive]="true"></app-tag>

                  <div class="tag mr-10">
                    {{ operation.quantity | digitFormat }}
                    <span class="tag-addon"><i class="fa fa-layer-group"></i></span>
                  </div>
                  <div class="tag mr-10">
                    <span>{{ operation.timeEstimatedEmployee | digitFormat }}min</span>
                    <span *ngIf="operation.workersCount > 1" class="ml-1">x{{ operation.workersCount }}</span>
                    <span class="tag-addon"><i class="fa fa-user"></i></span>
                  </div>
                  <div class="tag">
                    {{ operation.timeEstimatedMachine | digitFormat }}min
                    <span class="tag-addon"><i class="fa fa-cog"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question" (click)="emitFalse()">Nazad</button>
    </div>
  </div>
</div>
